export const FAILED = 'failed';
export const GRANDFATHERED = 'grandfathered';
export const PENDING = 'pending';
export const VERIFIED = 'verified';
export const VIRTUAL = 'virtual';

const VALID = [GRANDFATHERED, VERIFIED, VIRTUAL];

export const isVerified = (org) => VALID.includes(org.verification_status);
